// VotreFormulaire.js
import React, { useState } from "react";
import "./VotreFormulaire.css"; // Assurez-vous que le chemin est correct pour votre fichier CSS
import Contact from "./Contact";
import { Helmet } from "react-helmet-async";
import { getApiBaseUrl } from "./config/api";

function VotreFormulaire() {
  const [step, setStep] = useState(1);

  // Partie 1 - Modèle et mécanique
  const [marque, setMarque] = useState("");
  const [modele, setModele] = useState("");
  const [boiteVitesse, setBoiteVitesse] = useState("");
  const [carburant, setCarburant] = useState("");
  const [kilometrage, setKilometrage] = useState("");
  const [couleur, setCouleur] = useState("");
  const [options, setOptions] = useState("");
  const [budget, setBudget] = useState("");
  const [puissance, setPuissance] = useState("");
  const [year, setYear] = useState("");

  // Partie 3 - Bénéficiez-vous d'une reprise
  const [repriseMarque, setRepriseMarque] = useState("");
  const [repriseModele, setRepriseModele] = useState("");
  const [repriseKilometrage, setRepriseKilometrage] = useState("");
  const [repriseYear, setRepriseYear] = useState("");
  const [repriseImmat, setRepriseImmat] = useState("");

  const [isChecked, setIsChecked] = useState(false);

  // Partie 4 - Nous vous rappelons
  const [nom, setNom] = useState("");
  const [numeroTelephone, setNumeroTelephone] = useState("");
  const [website, setWebsite] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const validateForm = () => {
    if (nom.trim().length < 2) {
      setSubmitError("Indiquez votre nom.");
      return false;
    }
    if (!/^[+()\d .-]{8,30}$/.test(numeroTelephone.trim())) {
      setSubmitError("Indiquez un numéro de téléphone valide.");
      return false;
    }
    setSubmitError("");
    return true;
  };

  const nextStep = () => {
    window.scrollTo(0, 0);
    setStep(step + 1);
  };

  const prevStep = () => {
    // remonte en haut de la page
    window.scrollTo(0, 0);
    setStep(step - 1);
  };

  const sendForm = async () => {
    if (validateForm() && !isSending) {
      setIsSending(true);
      const data = {
        formulaire: "RECHERCHE PERSO",
        marque: marque,
        modele: modele,
        boiteVitesse: boiteVitesse,
        carburant: carburant,
        kilometrage: kilometrage,
        couleur: couleur,
        options: options,
        repriseMarque: repriseMarque,
        repriseModele: repriseModele,
        repriseKilometrage: repriseKilometrage,
        repriseYear: repriseYear,
        repriseImmat: repriseImmat,
        nom: nom,
        year: year,
        numeroTelephone: numeroTelephone,
        budget: budget,
        puissance: puissance,
        repriseSouhaitee: isChecked ? "Oui" : "Non",
        website,
      };

      // URL API depuis variable d'environnement
      const API_URL = getApiBaseUrl();
      
      try {
        const response = await fetch(`${API_URL}/api/sendEmail`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          window.scrollTo(0, 0);
          setStep(4);
        } else {
          const result = await response.json().catch(() => ({}));
          setSubmitError(result.error || "L’envoi a échoué. Réessayez ou contactez-nous par téléphone.");
        }
      } catch (error) {
        console.error("Error:", error);
        setSubmitError("Connexion impossible. Réessayez ou contactez-nous au 06 82 75 46 29.");
      } finally {
        setIsSending(false);
      }
    }
    return null;
  };

  return (
    <div>
      <Helmet>
        <title>Recherche personnalisée de véhicule | FLIP MY CAR</title>
        <meta name="description" content="Décrivez le véhicule de vos rêves et notre équipe se charge de le trouver. Service de recherche personnalisée chez FLIP MY CAR à Chambourcy (78)." />
        <link rel="canonical" href="https://flipmycar.fr/recherche-personnalisee" />
        <meta property="og:title" content="Recherche personnalisée | FLIP MY CAR" />
        <meta property="og:description" content="Décrivez le véhicule de vos rêves et notre équipe se charge de le trouver." />
        <meta property="og:url" content="https://flipmycar.fr/recherche-personnalisee" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://flipmycar.fr/logo2.png" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Recherche personnalisée | FLIP MY CAR" />
        <meta name="twitter:description" content="Décrivez le véhicule de vos rêves et notre équipe se charge de le trouver." />
      </Helmet>

      <h1 className="form-title">Recherche personnalisée</h1>
      <div className="formulaire-container">
        <div>
          {/* Partie 1 */}
          {step === 1 && (
            <div className="form-step">
              <h2>Étape 1 - Critères de recherche</h2>
              <br></br>
              <label className="labelmenuderoulant">
                <span className="label">Marque :</span>
                <input
                  type="text"
                  value={marque}
                  onChange={(e) => setMarque(e.target.value)}
                />
              </label>
              <label className="labelmenuderoulant">
                <span className="label"> Modèle :</span>
                <input
                  type="text"
                  value={modele}
                  onChange={(e) => setModele(e.target.value)}
                />
              </label>
              <label className="labelmenuderoulant">
                <span className="label"> Année minimum de mise en circulation :</span>
                <input
                  type="text"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                />
              </label>
              <label className="labelmenuderoulant">
                <span className="label">Transmission : </span>
                <select
                  value={boiteVitesse}
                  onChange={(e) => setBoiteVitesse(e.target.value)}
                  className="menudroulant"
                >
                  <option value="">Sélectionnez une boîte de vitesse</option>
                  <option value="Manuelle">Manuelle</option>
                  <option value="Automatique">Automatique</option>
                  {/* Ajoutez d'autres options au besoin */}
                </select>
              </label>
              <label className="labelmenuderoulant">
                <span className="label">Carburant :</span>
                <select
                  value={carburant}
                  onChange={(e) => setCarburant(e.target.value)}
                  className="menudroulant"
                >
                  <option value="">Sélectionnez un carburant</option>
                  <option value="Essence">Essence</option>
                  <option value="Hybride">Hybride</option>
                  <option value="Diesel">Diesel</option>
                  <option value="Electrique">Electrique</option>
                  {/* Ajoutez d'autres options au besoin */}
                </select>
              </label>
              <label className="labelmenuderoulant">
                <span className="label">Puissance en cv :</span>
                <input
                  type="text"
                  value={puissance}
                  onChange={(e) => setPuissance(e.target.value)}
                />
              </label>
              <label className="labelmenuderoulant">
                <span className="label"> Kilométrage Maximum : </span>
                <select
                  value={kilometrage}
                  onChange={(e) => setKilometrage(e.target.value)}
                  className="menudroulant"
                >
                  <option value="">Sélectionnez un kilométrage maximum</option>
                  <option value="Maximum 10 000 km">Maximum 10 000 km</option>
                  <option value="Maximum 25 000 km">Maximum 25 000 km</option>
                  <option value="Maximum 50 000 km">Maximum 50 000 km</option>
                  <option value="Maximum 75 000 km">Maximum 75 000 km</option>
                  <option value="Maximum 100 000 km">Maximum 100 000 km</option>
                  {/* Ajoutez d'autres options au besoin */}
                </select>
              </label>
              <label className="labelmenuderoulant">
                <span className="label"> Couleur exterieure :</span>
                <input
                  type="text"
                  value={couleur}
                  onChange={(e) => setCouleur(e.target.value)}
                />
              </label>
              <label className="labelmenuderoulant">
                <span className="label">Options :</span>
                <input
                  type="text"
                  value={options}
                  onChange={(e) => setOptions(e.target.value)}
                />
              </label>
              <label className="labelmenuderoulant">
                <span className="label">Budget :</span>
                <input
                  type="text"
                  value={budget}
                  onChange={(e) => setBudget(e.target.value)}
                />
              </label>
              <p style={{ color: "grey" }}>
                Tous les champs ne sont pas obligatoires
              </p>
              <button type="button" onClick={nextStep}>
                Suivant
              </button>
            </div>
          )}

          {/* Partie 2 */}
          {step === 2 && (
            // faire une case a cocher pour la reprise de l'ancien véhicule et si oui afficher la configuration de l'ancien véhicule si non masquer la partie configuration de l'ancien véhicule et afficher uniquement les champs de contact
            <div className="form-step">
              <h2>Étape 2 - Votre véhicule actuel</h2>

            <div className="checkbox">
                <input
                  className="reprisecheckbox"
                  type="checkbox"
                  id="reprise"
                  name="reprise"
                  value="reprise"
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                <label htmlFor="reprise">
                  Je souhaite bénéficier d'une reprise de mon ancien véhicule{" "}
                </label>
              </div>
              {isChecked && (
                <>
                  <label className="labelmenuderoulant">
                    <span className="label">Marque :</span>
                    <input
                      type="text"
                      value={repriseMarque}
                      onChange={(e) => setRepriseMarque(e.target.value)}
                    />
                  </label>
                  <label className="labelmenuderoulant">
                    <span className="label"> Modèle :</span>
                    <input
                      type="text"
                      value={repriseModele}
                      onChange={(e) => setRepriseModele(e.target.value)}
                    />
                  </label>
                  <label className="labelmenuderoulant">
                    <span className="label"> Kilométrage :</span>
                    <input
                      type="text"
                      value={repriseKilometrage}
                      onChange={(e) => setRepriseKilometrage(e.target.value)}
                    />
                  </label>
                  <label className="labelmenuderoulant">
                    <span className="label"> Année de mise en circulation :</span>
                    <input
                      type="text"
                      value={repriseYear}
                      onChange={(e) => setRepriseYear(e.target.value)}
                    />
                  </label>
                  <label className="labelmenuderoulant">
                    <span className="label"> Immatriculation :</span>
                    <input
                      type="text"
                      value={repriseImmat}
                      onChange={(e) => setRepriseImmat(e.target.value)}
                    />
                  </label>
                  <p style={{ color: "grey" }}>
                    Tous les champs ne sont pas obligatoires
                  </p>
                </>
              )}
              <br />
              <div className="selectpage">
                <button type="button" onClick={prevStep}>
                  Précédent
                </button>
                <button type="button" onClick={nextStep}>
                  Suivant
                </button>
              </div>
            </div>
          )}
          {/* Partie 3 */}
          {step === 3 && (
            <div className="form-step">
              <h2>Étape 3 - Nous vous rappelons</h2>
              <br></br>
              <label className="labelmenuderoulant">
                <span className="label">Nom :</span>
                <input
                  type="text"
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                  required
                />
              </label>
              <label className="labelmenuderoulant">
                <span className="label">Numéro de téléphone :</span>
                  <input
                  type="tel"
                  autoComplete="tel"
                  value={numeroTelephone}
                  onChange={(e) => setNumeroTelephone(e.target.value)}
                  required // Add the required attribute
                />
              </label>
              <div className="form-honeypot" aria-hidden="true">
                <label htmlFor="recherche-website">Site internet</label>
                <input id="recherche-website" type="text" value={website} onChange={(e) => setWebsite(e.target.value)} tabIndex="-1" autoComplete="off" />
              </div>
              {submitError && <p className="form-error" role="alert">{submitError}</p>}
              <div className="selectpage">
                <button type="button" onClick={prevStep}>
                  Précédent
                </button>
                <button type="button" onClick={sendForm} disabled={isSending}>
                  {isSending ? "Envoi en cours…" : "Envoyer"}
                </button>
              </div>
            </div>
          )}
          {/* Partie 4 */}
          {step === 4 && (
            <div className="form-step">
              <h2>Confirmation</h2>
              <p>Votre formulaire a été transmis à notre équipe.</p>
            </div>
          )}
        </div>
      </div>
      <Contact />
      <br />
      <div className="bannieredubas">
        <img
          src={process.env.PUBLIC_URL + "/IMG_6557.jpeg"}
          alt="bannieredubas"
          className="bannieredubas"
        />
      </div>
    </div>
  );
}

export default VotreFormulaire;
